import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export type DatasetRequestPayload = {
  name: string;
  email: string;
  company: string;
  useCase: string;
  dataType: string;
  description: string;
  timeline: string;
  budget: string;
};

export async function submitDatasetRequest(payload: DatasetRequestPayload): Promise<void> {
  const name = payload.name.trim();
  const email = payload.email.trim();
  const company = payload.company.trim();
  const useCase = payload.useCase.trim();
  const dataType = payload.dataType.trim();
  const description = payload.description.trim();
  const timeline = payload.timeline.trim();
  const budget = payload.budget.trim();
  const now = new Date();
  const submittedDate = now.toLocaleDateString();
  const submittedTime = now.toLocaleTimeString();

  if (!name || !email || !description || !useCase || !dataType) {
    throw new Error('Missing required fields: name, email, description, use case, and data type are required.');
  }

  await addDoc(collection(db, 'datasetRequests'), {
    name,
    email,
    company,
    useCase,
    dataType,
    description,
    timeline,
    budget,
    source: 'pixanowebsite',
    status: 'new',
    notes: '',
    createdAt: serverTimestamp(),
    submittedDate,
    submittedTime,
  });
}
